const CLINICAL_DOCUMENT_ROOTS = ["ClinicalDocument", "ContinuityOfCareRecord"];

/**
 * Determines whether the given XML is a clinical document the CDA Explorer can render
 * (a CDA `ClinicalDocument` or a `ContinuityOfCareRecord`). Other XML — e.g. a
 * `PatientEventNotification` — returns false so callers can fall back to the PDF preview.
 */
export function isClinicalDocumentXml(xml: string | undefined): boolean {
    if (!xml) return false;

    try {
        const doc = new DOMParser().parseFromString(xml, "application/xml");
        if (doc.querySelector("parsererror")) return false;

        const root = doc.documentElement?.localName;
        return !!root && CLINICAL_DOCUMENT_ROOTS.includes(root);
    } catch {
        return false;
    }
}
